<template>
  <div class="container is-fullhd container__section-list">
      <div class="section">
        <p class="title">{{ getListName }}</p>
        <p class="subtitle" v-if="!listEbooks || (listEbooks && listEbooks.length === 0)">No ebook in this list!</p>
        <b-message type="is-info" has-icon>
          Bookman earns an affiliate commission that help keeps the light on when you purchase a book trough it.
        </b-message>
        <chunked-ebooks-display :ebooks="listEbooks"/>
      </div>
  </div>
</template>

<script>
import chunkedEbooksDisplay from '@/components/chunked-ebooks-display'

export default {
  name: 'lists',
  props: {
    listUriParam: {
      type: String,
      default: ''
    }
  },
  created () {
    this.$store.dispatch('loadListEbooks', { uriParam: this.listUriParam })
  },
  watch: {
    listUriParam (value) {
      this.$store.dispatch('loadListEbooks', { uriParam: value })
    }
  },
  computed: {
    formattedListName () {
      return this.listUriParam.charAt(0).toUpperCase() + this.listUriParam.slice(1)
    },
    listEbooks () {
      return this.$store.getters.getEbooksList
    },
    getList () {
      return this.$store.getters.getList
    },
    getListName () {
      const list = this.getList
      if (list) {
        return list.name
      }
      return this.formattedListName
    }
  },
  components: {
    chunkedEbooksDisplay
  }
}
</script>

<style scss scoped>
.container__section-list {
    min-height: 88vh;
}

</style>
